import { gql } from '@apollo/client'

export const MINIMAL_STORE_FRAGMENT = gql`
  fragment MinimalStore on CompanyStore {
    id
    name
    category
    physicalStoreId
    image {
      url
      id
    }
    address {
      address1
      address2
      city
      state
      postalCode
    }
    point {
      latitude
      longitude
    }
  }
`
